import { client } from "./client";

// 신청서가 아직 없으면 백엔드가 404를 준다 (volunteers/views.py:
// MyVolunteerApplication.get_object). 호출부 입장에서 "아직 신청 안 함"은
// 오류가 아니라 하나의 상태이므로 null로 눕혀서 돌려준다.
export const fetchMyVolunteerApplication = async () => {
    try {
        const response = await client.get("/api/volunteers/applications/me/");
        return response.data;
    } catch (error) {
        if (error.response?.status === 404) {
            return null;
        }
        throw error;
    }
};
